/**
  * 广告创建 计划 组 创意的 一些配置说明文件
  */

import { Plan } from './ad-dim.js';



const parseItems = (result) => {
  return result.map(it => ({
    value : it.key,
    name : it.name
  }));
}
const getPlanType = Plan.getCampaignTypes;
const getDeliverPolicy = Plan.getDeliverPolicy;


export const SEARCH_KEYWORD_STATUS_LABEL = {
  2: '审核中',
  3: '审核通过',
  4: '审核驳回'
}
export const SEARCH_KEYWORD_STATUS = {
  CHECKING: 2,
  FAIL: 4,
  OK: 3
}

export const CAMPAIGN_DELIVERY = {
  UNIFORM: 1,
  ACCELERATE: 0
}

export const CAMPAIGN_TYPE = {
  SHOP: 1,
  NONE_SHOP: 2,
  MIMENG: 3
};

export const SINGLE_PATE_TYPE = {
  APP_SITE: 1,
  LEGO_SITE: 2,
  VIDEO_SITE: 3
};

export const CAMPAIGN_TYPE_LABEL = {
  [CAMPAIGN_TYPE.SHOP]: '商店',
  [CAMPAIGN_TYPE.NONE_SHOP]: '非商店',
  [CAMPAIGN_TYPE.MIMENG]: '米盟'
};

export const AD_PLAN_MAP = {
  name : {label : '计划名称', key : 'name', placeholder : '请输入广告计划名称'},
  type : {label : '投放范围', key : 'type', items : getPlanType,  parseItems : parseItems, type : 'batch-btn' },
  budget : {label : '预算', key : 'budget'},
  deliverPolicy : {label : '投放方式', key : 'deliverPolicy', items : getDeliverPolicy , type : 'batch-btn'},
  autoOptimize : {label : '自动优化', key : 'autoOptimize', items : [{key: 0, value: 0, name: '不开启'}, {key: 1, value: 1, name: '开启', desc: '单计划下投放创意数≥3条效果更优'}] , type : 'batch-btn'},
  date : {label : '投放日期', key: 'date'},
  bidding: {label: '', key: 'bidding'}
}

export const AD_PLAN_ARRAY = ['type', 'budget', 'autoOptimize', 'bidding', 'deliverPolicy', 'date', 'name'];


export const AD_GROUP_MAP = {
  name : {label : '广告组名称', key : 'name', required : true},
  productType : {label : '推广目的', key : 'productType', required : true},
  appId : {label : '应用Id', key : 'appId', required : true},
  displayType : {label : '版位选择', key : 'displayType', required : true},
  direction : {label : '定向', key : 'direction', required : true}
};

export const AD_GROUP_DISPLAY_ARRAY = [
  'productType', 'appId', 'displayType'
];

export const AD_GROUP_DIRECTION_MAP = {
  media : '媒体定向',
  base : '基础定向',
  user : '用户定向',
  action : '用户行为',
  push : '通知栏推送'
};

export const AD_CREATIVE_MAP = {
  name : {label : '广告创意名称', key : 'name', required : true},
  img : {label : '素材', key : 'img', required : true},
  bid : {label : '出价', key : 'bid', required : true},

};

export const ASIDE_ITEM_STATUS = {
  NO_CHECK :  0, //'未校验',
  UN_VALIDATE : -1,  // '不合法',
  VALIDATE : 1  //'合法'
};

export const GROUP_TYPE = {
  NORMAL: 0, // 普通广告组
  PROGRAM: 1 // 程序化广告组
};

export const PRIVILEGE = {
  RTA_TOKEN: 'subaccount.rta,subaccount.rta.app',
  CHANNEL: 'channelpackage',
  PT_OFFLINE: 'pt_offline'
};

export const PROGRAM_STATUS = {
  NO_MANAGED: {
    key: 0,
    name: '未启用托管'
  },
  MANAGING: {
    key: 1,
    name: '托管中'
  },
  MANAGED_STOP: {
    key: 2,
    name: '托管终止'
  },
  NAMAGED_END: {
    key: 3,
    name: '托管完成'
  },
  MANAGED_STOP_NOT_ENOUGH_ASSET: {
    key: 4,
    name: '托管完成(无法探索)'
  },
  MAN_MADE_STOP: {
    key: 100,
    name: '托管终止(人为终止)'
  },
  AUDIT_FAILED_MADE_STOP: {
    key: 101,
    name: '托管终止(审核未通过)'
  },
  EFFECT_BEST: {
    key: 102,
    name: '托管完成(效果最好)'
  },
  EFFECT_BETTER: {
    key: 103,
    name: '托管完成(效果较好)'
  },
  EFFECT_BAD: {
    key: 104,
    name: '托管完成(效果不好)'
  },
  EFFECT_UNKNOW: {
    key: 105,
    name: '托管完成(无法探索)'
  }
};

export const PROGRAM_MANAGE_STATUS = {
  AUTO: 1, // 启用托管
  NORMAL: 0
};

export const AD_CREATIVE_INFO_MAP = {
  icon : {
    key : 'icon',
    options : {
      label: '品牌ICON',
      width: 140,
      height: 140,
      placeholder : '140px * 140px <br> JPG、JPEG、PNG格式</br> &lt;500KB'
    }
  },
  headImg : {
    key : 'icon',
    options : {
      label: '头像',
      type: 'image',
      paramName: 'headImg',
      width: 200,
      height: 200,
      placeholder : '200px * 200px<br/><500KB<br/>JPEG、JPG、PNG格式<br/>',
      desc: '200px * 200px<br/><500KB<br/>JPEG、JPG、PNG格式<br/>'
    }
  },
  name : {
    label : '创意名称',
    options : {
      placeholder : '请输入创意名称',
      maxlength : 200,
      paramName : 'name' 
    }
  },
  text : {
    key : 'text',
  },
  brand : {
    label : '广告品牌描述',
    key : 'brand',
    options : {
      placeholder : '需包含公司名称或者产品名称',     
      maxlength : 10,
    }
  },
  productDescription : {
    label : '推广产品描述',
    key : 'productDescription',
    options : {
      placeholder : '请输入推广产品描述',
      maxlength : 15
    }
  },
  phone : {
    label : '拨打电话描述',
    key : 'phone',
    options : {
      placeholder : '拨打电话描述',
      maxlength : 4
    },
    phoneNumber : {
      label : '电话号码',
      key : 'phoneNumber',
    }
  },
  downloadUrl : {
    label : '下载链接',
    key : 'downloadUrl',
    options : {
      placeholder : '请输入下载链接'
    }
  }
};

export const TRACK_TYPE = {
  API_REPORT: 2, //API上报方案
  API_STATISTICAL: 1, //API统计方案
  MI_DATA: 3, //小米数据
  MI_SHOP_DATA: 6 //小米商店数据
};

export const CONVERSION_TYPE = {
  LH: 9, // 拉活
  ACTIVATION: 7, // 激活
  NEW_ACTIVATION: 8, // 新增激活
  CUSTOM_ACTIVATION: 1, // 自定义激活
  CUSTOM_REGISTER: 2, // 自定义注册
  CUSTOM_KEEP: 3, // 自定义留存
  CUSTOM_NEW_ACTIVATION: 5, // 自定义新增激活
  PAID: 6, // 付费
};

export const CONVERSION_TARGET_UNIT = {
  YUAN: 1,
  SI: 2,
  FEN: 3,
  PERCENTAGE: 10
};

export const CONVERSION_UNIT_LABEL = {
  [CONVERSION_TARGET_UNIT.YUAN]: '元',
  [CONVERSION_TARGET_UNIT.PERCENTAGE]: '%',
};

// 广告组 推广目的
export const GROUP_PRODUCT_TYPE = {
  URL: 1, // 网址
  APP_DOWNLOAD: 2, // 应用下载
  CUSTOM_DOWNLOAD: 8, // 自定义下载
  QUICK_APP: 16 // 自定义下载
};

export const GROUP_PRODUCT_TYPE_LABEL = {
  [GROUP_PRODUCT_TYPE.URL]: '网址',
  [GROUP_PRODUCT_TYPE.APP_DOWNLOAD]: '应用下载',
  [GROUP_PRODUCT_TYPE.CUSTOM_DOWNLOAD]: '自定义下载',
  [GROUP_PRODUCT_TYPE.QUICK_APP]: '快应用'
};

// 广告组 广告位对应 id
export const GROUP_DISPLAY_TYPE = {
  INFOFEED: '1', // 信息流
  VIDEO: '2', // 视频
  FOCUS_IMG: '4', // 焦点图
  START_SCREEN: '5', // 开屏
  TABLE_PLAQUE: '6', // 插屏
  BANNER: '7', // Banner
  SMART_MESSAGE: '9', // 智能短信
  NONE_SHOP_SEARCH: '16', // 非商店搜索广告
  ENTERTAINMENT_INFOFEED: '30', // 娱乐信息流
  VERTICAL_VIDEO: '31', // 竖版视频
  NOTICE_BAR: '32', // 通知栏
  HOME_FOCUS_IMG: '18', // 首页焦点图
  BOUTIQUE_LIST: '19', // 精品列表广告
  SEARCH: '20', // 搜索广告
  SEARCH_RICH_MEDIA: '21', // 搜索富媒体广告
  ESSENTIAL_APP: '22', // 装机必备广告
  LEADER_BOARD: '23', // 排行榜广告
  RED_SPECIAL: '24', // 红包专场广告
  INSTALLED_ROTINE: '25', // 装机例行活动
  APP_RECOMMEND: '28', // 应用相关推荐
  APP_STORE_START_SCREEN: '33', // 应用商店-开屏
  MIMENG_INFOFEED: '10', // 米盟-信息流
  MIMENG_BANNER: '11', // 米盟-横幅
  MIMENG_START_SCREEN: '13', // 米盟-开屏
  MIMENG_TABLE_PLAQUE: '14', // 米盟-插屏
  MIMENG_VIDEO: '15', // 米盟-视频
  MIMENG_PP: '29', // 米盟-皮皮搞笑
  MIMENG_INCENTIVE: '12', // 米盟-激励广告
  NOTICE_BAR_MSA: '38' // 米盟-激励广告
};

export const ASSET_AUDIT_STATUS = {
  REMOVED: 0, //已删除
  OK: 1, //有效
  PAUSE: 2, //暂停
  CHECKING: 3, //审核中
  FAIL: 4, //审核未通过
  FROZEN: 5 //冻结
};
// 转化目标出价底价
export const OCPX_BID_LIMIT = {
  OCPC: 2,
  OCPD: 3,
  LH: 0.12,
  ACTIVATION: 1
};

export const BILLING_TYPE = {
  OCPC: 101,
  OCPD: 102
};
// 广告类型
export const AD_TYPE = {
  NORMAL: 0, //普通广告
  SINGLE_DPA: 1, //单商品广告
  MULTI_DPA: 2, //多商品广告
  YUYUE: 3,
  WX_PROGRAM: 4
};
// 广告类型
export const DPA_TYPE = {
  NORMAL: 0, //普通广告
  SINGLE_DPA: 1, //单商品广告
  MULTI_DPA: 2, //多商品广告
  YUYUE: 3
};
// 创意类型
export const PLACEMENT_TYPE = {
  SEARCH_AD: 26,
  SEARCH_RICH_MEDIA:  165
};